import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DownloadK8sAgentData } from '../types/download-k8s-agent-data';

export abstract class DownloadK8sAgentBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getK8sScriptData(companyId: string): Promise<DownloadK8sAgentData>;

  public abstract getAvailableCompanyIdsWithKspm(): Promise<string[]>;
}
